function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7458 26.5996L29.1418 26.1692C31.4391 23.6724 32.7358 20.4139 32.7358 16.9513C32.7358 9.43031 26.6388 3.33337 19.1179 3.33337C11.5969 3.33337 5.5 9.43031 5.5 16.9513C5.5 24.4722 11.5969 30.5691 19.1179 30.5691C21.616 30.5691 24.0139 29.8961 26.1092 28.64L26.5174 28.3953L34.372 36.25C34.9276 36.8056 35.8285 36.8056 36.3841 36.25C36.9397 35.6944 36.9397 34.7935 36.3841 34.2379L28.7458 26.5996ZM19.1179 27.7236C13.1685 27.7236 8.34553 22.9007 8.34553 16.9513C8.34553 11.0019 13.1685 6.1789 19.1179 6.1789C25.0673 6.1789 29.8902 11.0019 29.8902 16.9513C29.8902 22.9007 25.0673 27.7236 19.1179 27.7236Z",
  fill: "#A9A9A9"
});

function SvgNoResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/no-result.dc9ea096.svg";
export { ForwardRef as ReactComponent };